// extracted by mini-css-extract-plugin
export default {"rowCell":"hGA2f","adminCell":"dwqU8","adminName":"dIxmd","adminEmail":"RLi0z","results":"RJlQO","resultsOpened":"ZIlxD","resultsTriggerIcon":"ZGxka","resultsTable":"uPOug"};